module.exports = __webpack_public_path__ + "img/double-right.21ef1647.svg";